<template>
  <div class="main-back d-flex">

    <Sidebar />

    <div class="main-content flex-grow-1">

      <AdminHeader />

      <!-- محتوای صفحه -->
      <div class="page-wrapper">

        <div class="page-card">

             <slot />

   <AppAlert
  :show="alertStore.show"
  :type="alertStore.type"
  :title="alertStore.title"
  :message="alertStore.message"
  @close="alertStore.close()"
/>

    <GlobalLoading />


        </div>

      </div>

    </div>

  </div>
</template>

<script setup>
import Sidebar from "@/components/AdminSidebar.vue";
import AdminHeader from "@/components/AdminHeader.vue";
import AppAlert from "@/components/alerts/AppAlert.vue";
import { alertStore } from "@/stores/alertStore"
import GlobalLoading from "@/components/GlobalLoading.vue";

</script>

<style>

.main-back{
  background: #f8f9fa;
  min-height: 100vh;
}


/* =========================
   CONTENT AREA
========================= */

.main-content{
  display: flex;
  flex-direction: column;
  width: 100%;
}


/* فاصله از هدر */

.page-wrapper{
  padding: 0 24px 24px 24px;
}


/* کارت اصلی محتوا */

.page-card{
  background: white;
  border-radius: 18px;
  padding: 24px;
  min-height: calc(100vh - 130px);
  box-shadow: 0 4px 22px rgba(80,80,120,0.08);
}


/* =========================
   RESPONSIVE
========================= */

@media (max-width: 991px){

  .page-wrapper{
    padding: 0 18px 18px 18px;
  }

  .page-card{
    padding: 20px;
    border-radius: 16px;
  }

}

@media (max-width: 768px){

  .page-wrapper{
    padding: 0 14px 14px 14px;
  }

  .page-card{
    padding: 16px;
    border-radius: 14px;
  }

}

@media (max-width: 576px){

  .page-wrapper{
    padding: 0 12px 12px 12px;
  }

  .page-card{
    padding: 14px;
  }

}

</style>
